<template>
  <div class="grid">
    <div class="grid-title">
      <h4>{{ $t("PROMOTION_INFO") }}</h4>
    </div>
    <v-spacer />
    <v-progress-linear color="warning" indeterminate rounded height="3" v-if="isLoading"></v-progress-linear>
    <v-form ref="form" lazy-validation v-on:submit.prevent v-if="editedItem && !isLoading">
      <div class="grid-body p-3 border-top-unset mb-3">
        <!-- Tên và mô tả mở rộng -->
        <v-row class="mt-0">
          <v-col sm="12">
            <v-tabs v-model="tab" class="pl-0">
              <v-tab>{{ $t("DEFAULT") }}</v-tab>
              <v-tab v-for="name in languages" :key="name">{{ name }}</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab" class="mt-3">
              <v-tab-item>
                <label>{{ $t("PROMOTION_TITLE") }} *</label>
                <v-text-field v-model="editedItem.nameVi" counter maxlength="250" class="input-counter"
                  v-on:keyup="updateRoomTitle(editedItem.nameVi)" :rules="ruleName" outlined dense>
                </v-text-field>
                <label class="mt-3">{{ $t("SERVICE.DESCRIPTION_INFO_DEFAULT") }}</label>
                <v-textarea counter="3000" maxlength="3000" class="input-counter" :rows="6"
                  v-model="editedItem.descriptionVi" v-on:keyup="updateRoomDescription(editedItem.descriptionVi)" outlined
                  dense :rules="ruleDescNotRequired">
                </v-textarea>
              </v-tab-item>
              <v-tab-item v-for="code in codeLangs" :key="code">
                <label>{{ $t("PROMOTION_PACKAGE_NAME") }} *</label>
                <v-text-field counter maxlength="250" class="input-counter"
                  v-model="editedItem.promotionI18n.find(x => x.lang == code).name" outlined dense :rules="ruleName">
                </v-text-field>
                <label class="mt-3">{{ $t("DESCRIPTION_INFO") }}</label>
                <v-textarea counter="3000" maxlength="3000" class="input-counter" :rows="6"
                  v-model="editedItem.promotionI18n.find(x => x.lang == code).description" outlined dense
                  :rules="ruleDescNotRequired">
                </v-textarea>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
        <v-divider />

        <label class="label-title">{{ $t("DETAIL") }}</label><br>
        <v-row>
          <!-- Mã khuyến mại -->
          <v-col sm="4">
            <label>{{ $t("PROMOTION_CODE") }} *</label>

            <v-text-field v-model="editedItem.promotionCode" v-on:keyup="validatePromotionCode(editedItem.promotionCode)"
              :disabled="
                $route.params.id != '00000000-0000-0000-0000-000000000000' && !isCopy
              " :rules="ruleCode" :error="isDuplicatePromotionCode" outlined dense counter maxlength="20"
              class="input-counter code">
            </v-text-field>
            <small v-if="isDuplicatePromotionCode" class="invalid-text">{{
              $t("CODE_NOT_EMPTY")
            }}</small>
          </v-col>
          <!-- Hình thức khuyến mại -->
          <v-col sm="4">
            <label>{{ $t("PROMOTION_TYPE") }} *</label>
            <v-select item-text="value" item-value="id" :items="select.proType" v-model="editedItem.promotionType"
              outlined dense>
            </v-select>
          </v-col>
          <!-- Áp dụng -->
          <v-col sm="4">
            <label>{{ $t("APPLY") }}</label>
            <v-select item-text="value" item-value="id" :items="select.discount" v-model="editedItem.discountType"
              outlined dense>
            </v-select>
          </v-col>
        </v-row>
        <v-row class="mt-0">
          <v-col sm="10" v-if="![6].includes(editedItem.promotionType)">
            <v-row>
              <v-col md="3" class="pt-0">
                <label>{{ $t("DISCOUNT_AND_SURCHARGES") }} *</label>
                <vuetify-number v-model="editedItem.amount" :options="amountOptionsPercent" dense
                  :rules="[rules.required, rules.maxPercent]" outlined v-if="editedItem.percent" />
                <v-text-field 
                  v-model="pricePromotion" 
                  :options="currency == 'VND' ? amountOptionsVi : amountOptionsEn" dense 
                  :rules="[rules.required]" 
                  outlined 
                  v-if="!editedItem.percent"
                  ref="pricePromotion"
                  @keydown="keyCurrencyDown($event, currency)"
                  :key="`pricePromotion_${forceRenderKey}`"
                 />
              </v-col>
              <!-- Đơn vị giảm -->
              <v-col md="2" class="pt-0">
                <label>{{ $t("DEPOSIT_UNIT") }} *</label>
                <v-select :items="select.unit" item-text="value" item-value="id" v-model="editedItem.percent" outlined
                  dense class="text-uppercase" :rules="[rules.select]" @change="changeRuleAmount()"></v-select>
              </v-col>
              <!-- Nếu là coupon -->
              <v-col md="2" class="pt-0" v-if="[3].includes(editedItem.promotionType)">
                <label>{{ $t("COUPON_CODE") }} *</label>
                <v-text-field v-model="editedItem.coupon" dense outlined>
                </v-text-field>
              </v-col>
              <!-- Nếu là đặt trước x ngày nhận phòng  -->
              <v-col md="2" class="pt-0" v-if="[4, 5].includes(editedItem.promotionType)">
                <label>{{ $t("X_DAYS") }} *</label>
                <v-text-field v-model="editedItem.xdays" dense outlined>
                </v-text-field>
              </v-col>

              <!-- Nếu là đặt trước x ngày nhận phòng  -->
              <v-col md="2" class="pt-0" v-if="[7].includes(editedItem.promotionType)">
                <label>{{ $t("MIN_COUNT") }} (x) *</label>
                <vuetify-number v-model="editedItem.xorder" :options="amountOptionsVi" dense
                  :rules="[rules.required, rules.maxPercent, rules.number]" outlined />
              </v-col>

              <v-col md="5" class="pt-0" v-if="[7].includes(editedItem.promotionType)">
                <label>{{ $t("APPLY_WITH") }} *</label>
                <v-radio-group row v-model="editedItem.orderType" class="mt-2">
                  <v-radio color="indigo darken-3" :label="$t('NIGHT_STAY')" :value="0"></v-radio>
                  <v-radio color="indigo darken-3" :label="$t('ROOM_BOOK_QUANTITY')" :value="1"></v-radio>
                </v-radio-group>
              </v-col>


            </v-row>
          </v-col>

          <v-col sm="10" v-if="[6].includes(editedItem.promotionType)">
            <v-row>
              <v-col md="2" class="pt-0">
                <label>{{ $t("MIN_COUNT") }} (x) *</label>
                <vuetify-number v-model="editedItem.xorder" :options="amountOptionsVi" dense
                  :rules="[rules.required, rules.maxPercent, rules.number]" outlined />
              </v-col>

              <v-col md="5" class="pt-0">
                <label>{{ $t("APPLY_WITH") }} *</label>
                <v-radio-group row v-model="editedItem.orderType" class="mt-2">
                  <v-radio color="indigo darken-3" :label="$t('NIGHT_STAY')" :value="0"></v-radio>
                  <v-radio color="indigo darken-3" :label="$t('ROOM_BOOK_QUANTITY')" :value="1"></v-radio>
                </v-radio-group>
              </v-col>

              <v-col md="3" class="pt-0">
                <label>{{ $t("QUANTITY_IS_FREE") }} *</label>
                <vuetify-number v-model="editedItem.yorder" :options="amountOptionsVi" dense
                  :rules="[rules.required, rules.maxPercent, rules.number]" outlined />
              </v-col>
            </v-row>
          </v-col>
          <v-col md="2" class="pb-0">
            <label>{{ $t("STATUS") }}</label>
            <v-checkbox class="mr-2 mt-2" color="indigo darken-3" :label="$t('ACTIVE')" v-model="editedItem.status" />
          </v-col>
        </v-row>
        <v-divider />

        <label class="label-title">{{ $t("SERVICE.TIME_APPLY") }}</label>
        <v-row class="mt-0">
          <v-col sm="12" class="pt-0">
            <v-row class="align-center mt-0">
              <v-col sm="3">
                <label>{{ $t("TIME_SET") }}</label>
              </v-col>
              <v-col sm="9">
                <v-radio-group row v-model="editedItem.bookingSession" class="mt-2">
                  <v-radio color="indigo darken-3" :label="$t('ALWAYS')" :value="false"></v-radio>
                  <v-radio color="indigo darken-3" :label="$t('IN_PERIOD')" :value="true"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row class="align-center mt-0">
              <v-col sm="3" class="py-0">
                <label>{{ $t("FROM_DATE") }}</label>
                <date-picker :model.sync="editedItem.startBookingDate" :error.sync="errors.startBookingDate"
                  :disabled="!editedItem.bookingSession" :min="currentDatePicker" />
              </v-col>
              <v-col sm="3" class="py-0">
                <label>{{ $t("TO_DATE") }}</label>
                <date-picker :model.sync="editedItem.endBookingDate" :min="editedItem.startBookingDate"
                  :error.sync="errors.endBookingDate" :disabled="!editedItem.bookingSession" />
              </v-col>
              <v-col v-if="editedItem.bookingSession" sm="2" class="py-0">
                <label>{{ $t("FROM_TIME") }}</label>
                <vue-timepicker format="HH:mm:ss" v-model="editedItem.startBookingTime" auto-scroll hide-clear-button
                  :class="errors.startBookingTime ? 'error w-100' : 'w-100'"></vue-timepicker>
              </v-col>
              <v-col v-if="editedItem.bookingSession" sm="2" class="py-0">
                <label>{{ $t("TO_TIME") }}</label>
                <vue-timepicker format="HH:mm:ss" v-model="editedItem.endBookingTime" hide-clear-button
                  class="w-100"></vue-timepicker>
              </v-col>
            </v-row>
          </v-col>
          <v-col sm="12" class="pt-0">
            <v-row class="align-center mt-0">
              <v-col sm="3">
                <label>{{ $t("TIME_STAY") }}</label>
              </v-col>
              <v-col sm="9">
                <v-radio-group row v-model="editedItem.stayingSession" class="mt-2">
                  <v-radio color="indigo darken-3" :label="$t('ALWAYS')" :value="false"></v-radio>
                  <v-radio color="indigo darken-3" :label="$t('IN_PERIOD')" :value="true"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row class="align-center mt-0">
              <v-col sm="3" class="py-0">
                <label>{{ $t("FROM_DATE") }}</label>
                <date-picker :model.sync="editedItem.startStayingDate" :error.sync="errors.startStayingDate"
                  :disabled="!editedItem.stayingSession" :min="currentDatePicker" />
              </v-col>
              <v-col sm="3" class="py-0">
                <label>{{ $t("TO_DATE") }}</label>
                <date-picker :model.sync="editedItem.endStayingDate" :min="editedItem.startStayingDate"
                  :error.sync="errors.endStayingDate" :disabled="!editedItem.stayingSession" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-divider />

        <v-row class="mt-0">
          <v-col md="2" class="pb-0">
            <label>{{ $t("APPLY_DAY") }}</label>
            <v-select item-text="text" item-value="value" :items="selectFromCheckout" dense outlined
              v-model="editedItem.fromCheckout">
            </v-select>
          </v-col>
          <v-col md="2" class="pb-0">
            <label>{{ $t("NON_REFUNDABLE") }}</label>
            <v-radio-group row v-model="editedItem.nonrefundable" class="mt-2">
              <v-radio color="indigo darken-3" :label="$t('YES')" :value="false"></v-radio>
              <v-radio color="indigo darken-3" :label="$t('NO')" :value="true"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col sm="8" class="pb-0">
            <label>{{ $t("_SERVICE_PACKAGE.DAY_APPLY_IN_WEEK") }}</label>
            <v-layout wrap>
              <v-chip-group v-model="dayApply" column multiple active-class="primary">
                <v-chip v-for="date in daysOfWeek" :value="date.date" class="chip-date">
                  {{ date.text }}
                </v-chip>
              </v-chip-group>
            </v-layout>
          </v-col>
        </v-row>

        <!-- Khoảng ngày không áp dụng -->
        <v-divider />
        <label class="label-title">{{ $t("NOT_APPLY_RANGE_DATE") }}</label>
        <p class="m-0 mt-4">{{ $t("APPLY_FOR_BOOKING") }}</p>
        <v-row class="mt-0">
          <v-col sm="12" class="pb-0">
            <v-row>
              <v-col sm="6" class="pt-0" v-for="(range, i) in editedItem.promotionBlackoutsBooking" :key="i">
                <v-row class="align-center">
                  <v-col sm="6" class="pb-0 pt-0">
                    <label>{{ $t("FROM_DATE") }}</label>
                    <date-picker :model.sync="range.startBookingDate" :min="currentDate()" class="outlined"
                      @changeData="isConfirmSave = true" />
                  </v-col>
                  <v-col sm="5" class="pb-0 pt-0 pr-0">
                    <label>{{ $t("TO_DATE") }}</label>
                    <date-picker :model.sync="range.endBookingDate" :min="range.startBookingDate"
                      @changeData="isConfirmSave = true" />
                  </v-col>
                  <v-col sm="1">
                    <v-icon class="pt-4" color="indigo" @click="
                      removeRangeApplyDate(i);
                    isConfirmSave = true;
                                            ">delete</v-icon>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <div>
              <v-btn small class="btn-expand mt-1" outlined depressed @click="
                addnotApplyDates();
              isConfirmSave = true;
                                ">
                <v-icon>
                  add
                </v-icon>
                {{ $t("ADD_RANGE_DAYS_NOT_APPLY") }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <p class="m-0 mt-4">{{ $t("APPLY_FOR_STAYING") }}</p>
        <v-row class="mt-0">
          <v-col sm="12" class="pb-0">
            <v-row>
              <v-col sm="6" class="pt-0" v-for="(range, i) in editedItem.promotionBlackoutsStaying" :key="i">
                <v-row class="align-center">
                  <v-col sm="6" class="pb-0 pt-0">
                    <label>{{ $t("FROM_DATE") }}</label>
                    <date-picker :model.sync="range.startBookingDate" :min="currentDate()" class="outlined"
                      @changeData="isConfirmSave = true" />
                  </v-col>
                  <v-col sm="5" class="pb-0 pt-0 pr-0">
                    <label>{{ $t("TO_DATE") }}</label>
                    <date-picker :model.sync="range.endBookingDate" :min="range.startBookingDate"
                      @changeData="isConfirmSave = true" />
                  </v-col>
                  <v-col sm="1">
                    <v-icon class="pt-4" color="indigo" @click="
                      removeRangeApplyDateStay(i);
                    isConfirmSave = true;
                                            ">delete</v-icon>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <div>
              <v-btn small class="btn-expand mt-1" outlined depressed @click="
                addnotApplyDatesStay();
              isConfirmSave = true;
                                ">
                <v-icon>
                  add
                </v-icon>
                {{ $t("ADD_RANGE_DAYS_NOT_APPLY") }}
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <!-- Gói bán áp dụng -->
        <v-divider />
        <label class="label-title">{{ $t("PACKAGE_APPLY") }}</label>
        <v-row>
          <v-col md="6" class="child-no-margin py-0" v-for="promotion in promotions" :key="promotion.id">
            <v-checkbox color="indigo darken-3" :label="promotion.name" :value="promotion.id" v-model="promotionPlans" />
          </v-col>
        </v-row>

        <div class="btn-bottom">
          <v-btn depressed class="mr-5" @click="back">{{ $t("BACK") }}</v-btn>
          <v-btn color="primary" class="pl-10 pr-10" @click="save" :loading="loading">{{
            $t("SAVE")
          }}</v-btn>
        </div>
      </div>

      <v-expansion-panels multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>{{
            $t("MORE_OPTIONS")
          }}</v-expansion-panel-header>
          <v-expansion-panel-content>
            <label class="label-title">{{ $t("_SERVICE_PACKAGE.APPLY_OBJECT") }}</label>
            <v-row>
              <v-col sm="12" class="pt-0">
                <v-select :items="promotionParties" item-text="text" item-value="value"
                  v-model="editedItem.promotionParties" outlined chips multiple :rules="[rules.select]">
                  <template v-slot:prepend-item>
                    <v-list-item ripple @click="toggleObject">
                      <v-list-item-action>
                        <v-icon :color="
                          editedItem.promotionParties.length > 0
                            ? 'indigo darken-4'
                            : ''
                        ">
                          {{ iconObject }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ $t("ALL") }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-0 mb-0"></v-divider>
                  </template>
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0 || index === 1 || index === 2">
                      <span>{{ item.text }}</span>
                    </v-chip>
                    <span v-if="index === 3" class="grey--text caption">(+{{ editedItem.promotionParties.length - 3
                    }})</span>
                  </template>
                  <template slot="no-data">
                    <div class="no-data">{{ $t("NO_DATA") }}</div>
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <v-divider />
            <label class="label-title">{{ $t("_ROOM_SALE.SELL_MARKET") }}</label>
            <v-row>
              <v-col>
                <v-radio-group v-model="applyAllMarket" class="mt-0" row>
                  <v-radio color="indigo darken-3" :label="$t('_ROOM_SALE.SELL_MARKET_ALL')" :value="'ALL'"
                    @change="applyAllMarketStatus()"></v-radio>
                  <v-radio color="indigo darken-3" :label="$t('_ROOM_SALE.SELL_MARKET_SPEC')" :value="'NOT_ALL'"
                    @change="applyAllMarketStatus()"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row v-if="listOfMarkets && applyAllMarket !== 'ALL'">
              <v-col md="3" class="child-no-margin py-0">
                <v-checkbox color="indigo darken-3" :label="$t('SELECT_ALL')" @change="clickSelectAllMarket()"
                  v-model="selectAllMarket" />
              </v-col>
              <v-col md="3" class="child-no-margin py-0" v-for="market in listOfMarkets" :key="market.id">
                <v-checkbox color="indigo darken-3" :label="market.value" :value="market.id"
                  v-model="editedItem.promotionMarkets" @change="
                    editedItem.promotionMarkets.length == listOfMarkets.length
                      ? (selectAllMarket = true)
                      : (selectAllMarket = false)
                  " />
              </v-col>
            </v-row>
            <v-divider />
            <div class="mr-3 pb-3 d-flex align-center" style="max-width: 350px">
              <label class="text-nowrap mr-2">{{
                $t("CHANNEL_APPLY")
              }}</label>
              <v-autocomplete dense outlined item-text="text" item-value="value" :items="listOtaConnectGlobal"
                v-model="selectedOTAGlobal" chips multiple style="width: 270px;" disabled>
                <template v-slot:selection="{ item, index }">
                  <v-chip color="primary" v-bind="item.attrs" :input-value="item.selected" >
                    <span>{{ item.text }}</span>
                  </v-chip>
                </template>
              </v-autocomplete>
            </div>
            <!-- <label class="label-title">{{ $t("_ROOM_SALE.SELL_CHANNEL") }}</label>
            <v-row>
              <v-col>
                <v-radio-group v-model="applyAllChannel" class="mt-0" row>
                  <v-radio color="indigo darken-3" :label="$t('_ROOM_SALE.SELL_CHANNEL_ALL')" :value="'ALL'"
                    @change="applyAllChannelStatus()"></v-radio>
                  <v-radio color="indigo darken-3" :label="$t('_ROOM_SALE.SELL_CHANNEL_SPEC')" :value="'NOT_ALL'"
                    @change="applyAllChannelStatus()"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row v-if="listOfChannels && applyAllChannel !== 'ALL'">
              <v-col md="3" class="child-no-margin py-0">
                <v-checkbox color="indigo darken-3" :label="$t('SELECT_ALL')" @change="clickSelectAllChannel"
                  v-model="selectAllChannel" />
              </v-col>
              <v-col md="3" class="child-no-margin py-0" v-for="channel in listOfChannels" :key="channel.id">
                <v-checkbox color="indigo darken-3" :label="channel.value" :value="channel.id"
                  v-model="editedItem.promotionChannels" @change="
                    editedItem.promotionChannels.length == listOfChannels.length
                      ? (selectAllChannel = true)
                      : (selectAllChannel = false)
                  " />
              </v-col>
            </v-row> -->
            <div class="btn-bottom">
              <v-btn color="primary" class="pl-10 pr-10" @click="save" :loading="loading">{{
                $t("SAVE")
              }}</v-btn>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-form>
  </div>
</template>
<style lang="scss" scoped>
.subtitle {
  text-transform: uppercase;
  font-size: 15px;
}

.invalid-text {
  color: red;
  margin-top: -15px;
  position: absolute;
}
</style>
<script>
import DatePicker from "@/components/Utils/DatePicker.vue";

import Input from "@/components/Utils/Input.vue";
import { promotion } from "@/_services/SaleRoom/promotion.js";
import { salePackageService } from "@/_services/SaleRoom/sale-package.service.js";

import { _alert } from "@/_helpers/function.js";
import { REGEX_NUMBER } from "@/_helpers/constant.js";
import { service } from "@/_services/RoomInfomation/list-of-rooms.service.js";
import {
  PROMOTION_TYPE_LIST,
  DISCOUNT_LIST,
  TARGET_APPLY_LIST,
  LEVEL_TARGET_APPLY,
  DAYS_OF_WEEK
} from "@/_helpers/config.js";
import moment from "moment";

// Main JS (in UMD format)
import VueTimepicker from "vue2-timepicker";

// CSS
import "vue2-timepicker/dist/VueTimepicker.css";

export default {
  components: {
    "date-picker": DatePicker,
    "input-text": Input,
    "vue-timepicker": VueTimepicker
  },
  async created() {
    this.currency = this.usedCurrency;
    this.select.unit = [{ id: false, value: this.usedCurrency }, { id: true, value: "%" }]
    await this.initialize();
  },
  mounted() { },
  data() {
    return {
      isDuplicatePromotionCode: false,
      currentDatePicker: moment()
        .startOf("day")
        .format("YYYY-MM-DD"),
      selectFromCheckout: [
        {
          text: this.$t("CHECKIN_DATE"),
          value: false
        }
        // {
        //   text: this.$t("CHECKOUT_DATE"),
        //   value: true
        // }
      ],
      dayApply: [],
      isConfirmSave: false,
      daysOfWeek: DAYS_OF_WEEK,
      isOpen: false,
      isLoading: false,
      isConfirmSave: false,
      listOfChannels: [],
      selectAllChannel: false,
      listOfMarkets: [],
      selectAllMarket: false,
      applyAllChannel: "ALL",
      applyAllMarket: "ALL",
      currency: this.usedCurrency,
      amountOptionsPercent: {
        locale: "vi",
        length: 3,
        precision: 0
      },
      amountOptionsVi: {
        locale: "vi",
        length: 9,
        precision: 0
      },
      amountOptionsEn: {
        locale: "vi",
        length: 9,
        precision: 2
      },
      rules: {
        required: value => !!value || this.$t("NOT_EMPTY"),
        number: value => value > 0 || this.$t("DATA_INPUT_INVALID"),
        select: value => value != null || this.$t("_REGISTER.REQUIRED_FIELD"),
        maxPercent: value =>
          value <= 100 || this.$t("DATA_INPUT_MAX_100_PERCENT"),
        maxNight: value => value <= 10 || this.$t("DATA_INPUT_MAX_10_NIGHT")
      },
      isEmptyDefaultTitle: false,
      editedItem: null,
      listSalePackage: [],
      // disabled: {
      //   startDate: null,
      //   endDate: null
      // },
      sysLang: this.$i18n.locale,
      tab: null,
      lang: "vi",
      select: {
        proType: PROMOTION_TYPE_LIST.map(x => {
          return {
            id: x.id,
            value: x.text
          };
        }),
        discount: DISCOUNT_LIST.map(x => {
          return {
            id: x.id,
            value: x.text
          };
        }),
        target: TARGET_APPLY_LIST.map(x => {
          return {
            id: x.id,
            value: x.text
          };
        }),
        promotion: [],
        unit: [{ id: false, value: "VND" }, { id: true, value: "%" }]
      },
      options: {
        daysOfWeek: DAYS_OF_WEEK.map(x => {
          return {
            id: x.id,
            text: x.text,
            value: x.date
          };
        }),
        levelTarget: LEVEL_TARGET_APPLY.map(x => {
          return {
            id: x.id,
            text: x.text,
            value: x.id
          };
        }),
        agentList: []
      },
      promotions: [],
      promotionPlans: [],
      errors: {
        startStayingDate: false,
        endStayingDate: false,
        startBookingDate: false,
        endBookingDate: false,
        startBookingTime: false,
        endBookingTime: false
      },
      discountAndSurError: {
        value: false,
        unit: false
      },
      isValid: true,
      promotionParties: [],
      isCopy: true,
      languages: JSON.parse(localStorage.getItem('listLangs')).length > 0 ? JSON.parse(localStorage.getItem('listLangs')).map(item => item.name) : [],
      codeLangs: JSON.parse(localStorage.getItem('listLangs')).length > 0 ? JSON.parse(localStorage.getItem('listLangs')).map(item => item.languageCode) : [],
      timeout: null,
      forceRenderKey: 0,
    };
  },
  computed: {
    pricePromotion: {
        get: function () {
            return this.convertDecimalViaLocal(this.editedItem.amount);
        },
        set: function (newValue) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
            const value = this.setCurrency(newValue);
            this.editedItem.amount = value;
            if (value == this.editedItem.amount) {
              this.forceRenderKey++;
              this.$nextTick(() => {
                if (this.$refs.pricePromotion && !this.editedItem.percent) {
                    this.$refs.pricePromotion.focus();
                }
              });
            }
            }, this.timeOutChange(newValue));
        }
    },
    REGEX_NUMBER() {
      return REGEX_NUMBER;
    },
    likesAllPromotionParties() {
      return (
        this.editedItem.promotionParties.length === this.promotionParties.length
      );
    },
    iconObject() {
      if (this.likesAllPromotionParties) return "mdi-close-box";
      if (this.likesSomePromotionParties) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    }
  },
  watch: {
    errors: {
      handler(value) {
        this.discountAndSurError = {
          value: value.amount.error,
          unit: null
        };
      },
      deep: true
    },
    tab(value) {
      this.lang = value ? "en" : "vi";
    },
    lang(value) {
      this.editorData = this.editedItem.promotionI18n.find(
        x => x.lang == value
      ).description;
    },
    editedItem: {
      handler(value) {
        if (value.startStayingDate > value.endStayingDate) {
          this.editedItem.endStayingDate = "";
        }
        if (value.startBookingDate > value.endBookingDate) {
          this.editedItem.endBookingDate = "";
        }
        // if (value.endBookingDate >= value.startStayingDate) {
        //   this.editedItem.startStayingDate = this._moment(value.endBookingDate)
        //     .add(1, "day")
        //     .format("YYYY-MM-DD");
        //   this.editedItem.endStayingDate = this._moment(value.endBookingDate)
        //     .add(2, "day")
        //     .format("YYYY-MM-DD");
        // }
      },
      deep: true
    },
    dayApply(value) {
      let tmp = [0, 0, 0, 0, 0, 0, 0];
      value.forEach(function (element) {
        if (element === "MON") {
          tmp[0] = 1;
        }

        if (element === "TUE") {
          tmp[1] = 1;
        }

        if (element === "WED") {
          tmp[2] = 1;
        }

        if (element === "THU") {
          tmp[3] = 1;
        }

        if (element === "FRI") {
          tmp[4] = 1;
        }

        if (element === "SAT") {
          tmp[5] = 1;
        }

        if (element === "SUN") {
          tmp[6] = 1;
        }
      });

      this.editedItem.bitWeekDays = parseInt(tmp.join(""), 2);
    }
  },
  methods: {
    updateRoomTitle(value) {
      if (value.length > 0) {
        this.isEmptyDefaultTitle = false;
        for (let i = 0; i < this.editedItem.promotionI18n.length; i++) {
          this.editedItem.promotionI18n[i].name = value;
        }
      } else {
        this.isEmptyDefaultTitle = true;
      }
    },
    updateRoomDescription(value) {
      for (let i = 0; i < this.editedItem.promotionI18n.length; i++) {
        this.editedItem.promotionI18n[i].description = value;
      }
    },
    changeRuleAmount() {
      this.editedItem.amount = null;
    },
    async initialize() {
      this.currency = this.priceOptionsVi.suffix;
      this.isLoading = true;
      await salePackageService.getApplyForObject().then(res => {
        this.promotionParties = res.data.map(x => {
          return {
            value: x.id,
            text: x.lookupItemI18n.find(x => x.lang == this.defaultI18n).name
          };
        });
        this.promotionParties = this.promotionParties.filter(x => x.value);
      });

      await service.getChannel().then(res => {
        this.listOfChannels = res.data.map(x => {
          return {
            id: x.id,
            value: x.lookupItemI18n.find(x => x.lang == this.defaultI18n).name
          };
        });
        this.listOfChannels = this.listOfChannels.filter(x => x.value);
      });

      await service.getMarket().then(res => {
        this.listOfMarkets = res.data.map(x => {
          return {
            id: x.id,
            value: x.lookupItemI18n.find(x => x.lang == this.defaultI18n).name
          };
        });
        this.listOfMarkets = this.listOfMarkets.filter(x => x.value);
      });

      let id = this.$route.params.id;
      if (id != "00000000-0000-0000-0000-000000000000") {
        await promotion.detail(id).then(res => {
          var tmp = [];
          this.convertFromBinaryToListSelection(res.data.bitWeekDays).forEach(
            function (element, index) {
              if (element == 1) {
                if (index == 0) {
                  tmp.push("MON");
                }
                if (index == 1) {
                  tmp.push("TUE");
                }
                if (index == 2) {
                  tmp.push("WED");
                }
                if (index == 3) {
                  tmp.push("THU");
                }
                if (index == 4) {
                  tmp.push("FRI");
                }
                if (index == 5) {
                  tmp.push("SAT");
                }
                if (index == 6) {
                  tmp.push("SUN");
                }
              }
            }
          );
          this.dayApply = tmp;

          this.editedItem = Object.assign({}, res.data);
          if (this.editedItem.promotionCode) {
            this.isCopy = false
          }
          if (!this.editedItem.promotionI18n) {
            this.codeLangs.forEach(e => {
              this.editedItem.promotionI18n.push({
                lang: e,
              })
            });
          }
          this.promotionPlans = this.editedItem.promotionPlans || [];

          if (res.data.promotionMarkets == null) {
            this.applyAllMarket = "ALL";
          } else {
            this.applyAllMarket = "NOT_ALL";
            if (res.data.promotionMarkets.length == this.listOfMarkets.length) {
              this.selectAllMarket = true;
            } else {
              this.selectAllMarket = false;
            }
          }
          if (res.data.promotionChannels == null) {
            this.applyAllChannel = "ALL";
          } else {
            this.applyAllChannel = "NOT_ALL";
            if (
              res.data.promotionChannels.length == this.listOfChannels.length
            ) {
              this.selectAllChannel = true;
            } else {
              this.selectAllChannel = false;
            }
          }
        });
      } else {
        this.dayApply = ["WED", "THU", "FRI", "SAT", "SUN", "TUE", "MON"];
        this.editedItem = {
          startBookingDate: this.currentDatePicker,
          endBookingDate: this._moment(this.currentDatePicker)
            .add(1, "day")
            .format("YYYY-MM-DD"),
          startStayingDate: this.currentDatePicker,
          endStayingDate: this._moment(this.currentDatePicker)
            .add(2, "day")
            .format("YYYY-MM-DD"),
          startBookingTime: "00:00:00",
          endBookingTime: "23:59:59",
          fromCheckout: false,
          nonrefundable: false,
          status: true,
          promotionType: 1,
          discountType: 0,
          percent: false,
          coupon: "",
          xorder: 1,
          yorder: 1,
          orderType: 0,
          amount: null,
          xdays: 0,
          ydays: 0,
          bitWeekDays: 127,
          bookingSession: false,
          stayingSession: false,
          promotionParties: [],
          promotionBlackoutsBooking: [],
          promotionBlackoutsStaying: [],
          promotionPlans: [],
          promotionI18n: [],
          sortIndex: 0
        };
        this.codeLangs.forEach(e => {
          this.editedItem.promotionI18n.push({
            lang: e,
            name: "",
            description: ""
          })
        });

      }

      // await promotion.get().then(res => {
      //   this.listSalePackage = res.data
      //     .filter(x => x.active)
      //     .map(x => {
      //       return {
      //         id: x.id,
      //         i18ns: x.i18ns
      //       };
      //     });
      // });
      // _resetErrorState(this.errors);
      if (!this.editedItem.promotionBlackoutsBooking) {
        this.editedItem.promotionBlackoutsBooking = [];
      }
      if (!this.editedItem.promotionBlackoutsStaying) {
        this.editedItem.promotionBlackoutsStaying = [];
      }
      this.editorData = this.editedItem.promotionI18n.find(
        x => x.lang == this.lang
      ).description;

      let body = {};
      body.keyword = null;
      body.status = null;
      body.limit = 1000;
      body.offset = 0;
      body.orderBy = "active";
      body.asc = false;
      salePackageService.getAllPlan(body).then(res => {
        this.promotions = res.data.map(x => {
          return {
            id: x.id,
            name: x.i18ns.find(x => x.lang == this.defaultI18n).name
          };
        });
      });

      this.isLoading = false;
    },
    convertFromBinaryToListSelection(number) {
      let output = parseInt(number, 10).toString(2);
      while (output.length < 7) {
        output = "0" + output;
      }
      return output.split("");
    },
    validateAndFocusTab() {
        if (!this.editedItem.nameVi) {
            this.tab = 0;
            return;
        }

        for (let i = 0; i < this.codeLangs.length; i++) {
            const langCode = this.codeLangs[i];
            const roomLang = this.editedItem.promotionI18n.find(x => x.lang === langCode);

            if (!roomLang || !roomLang.name) {
                this.tab = i + 1;
                return;
            }
        }
    },
    async save() {
      await this.validateAndFocusTab()
      await this.$nextTick();
      this.isValid = this.$refs.form.validate();
      // Validate thời gian đặt
      if (this.editedItem.bookingSession) {
        if (!this.editedItem.startBookingDate) {
          this.errors.startBookingDate = true;
          this.isValid = false;
        }
        if (!this.editedItem.endBookingDate) {
          this.errors.endBookingDate = true;
          this.isValid = false;
        }
        if (!this.editedItem.startBookingTime) {
          this.errors.startBookingTime = true;
          this.isValid = false;
        }
        if (!this.editedItem.endBookingTime) {
          this.errors.endBookingTime = true;
          this.isValid = false;
        }
      }
      // Validate thời gian ở
      if (this.editedItem.stayingSession) {
        if (!this.editedItem.startStayingDate) {
          this.errors.startStayingDate = true;
          this.isValid = false;
        }
        if (!this.editedItem.endStayingDate) {
          this.errors.endStayingDate = true;
          this.isValid = false;
        }
      }
      // this.isValid = this.$refs.form.validate();

      // if ([3, 4].includes(this.editedItem.promotionType)) {
      //   if (!this.editedItem.xdays) {
      //     this.isValid = false;
      //   }
      // }
      // if ([5, 6, 7].includes(this.editedItem.promotionType)) {
      //   if (!this.editedItem.xorder) {
      //     this.isValid = false;
      //   }
      // }

      if (this.isValid == false) {
        this.$store.commit("alert/display", {
          message: this.$t("MISSING_FIELD"),
          error: true,
          success: false
        });
        this.$nextTick(() => {
            const el = document.querySelector(".v-messages.error--text");
            if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
        });
        return false;
      }

      // Trùng mã cũng không được save
      if (this.isDuplicatePromotionCode) {
        this.$store.commit("alert/display", {
          message: this.$t("MISSING_FIELD"),
          error: true,
          success: false
        });
        return false;
      }

      this.editedItem.promotionPlans = this.promotionPlans;
      this.loading = true;
      if (this.$route.params.id != "00000000-0000-0000-0000-000000000000") {
        await promotion.update(this.editedItem).then(res => {
          _alert(res, this.$t(res.data));
          if (res.responseCode != 0) {
            // element.disabled = false;
          }
          this.loading = false;
        });
      } else {
        this.editedItem.promotionCode = this.editedItem.promotionCode.toUpperCase();
        await promotion.create(this.editedItem).then(res => {
          if (res.responseCode == 0) {
            _alert(res, this.$t("CREATE_SUCCESS"), false);
          }
          let vm = this;
          setTimeout(function () {
            vm.$router.push({ name: "promotionList" });
          }, 2000);
          if (res.responseCode != 0) {
            // element.disabled = false;
          }
          this.loading = false;
        });
      }
    },
    back() {
      this.$router.back();
    },
    applyAllMarketStatus() {
      if (this.applyAllMarket === "NOT_ALL") {
        this.editedItem.promotionMarkets = null;
        this.selectAllMarket = false;
      } else {
        this.editedItem.promotionMarkets = [];
      }
    },
    applyAllChannelStatus() {
      if (this.applyAllChannel === "NOT_ALL") {
        this.editedItem.promotionChannels = null;
        this.selectAllChannel = false;
      } else {
        this.editedItem.promotionChannels = [];
      }
    },
    clickSelectAllChannel() {
      if (this.selectAllChannel) {
        this.listOfChannels.forEach(e => {
          this.editedItem.promotionChannels.push(e.id);
        });
      } else {
        this.editedItem.promotionChannels = [];
      }
    },
    clickSelectAllMarket() {
      if (this.selectAllMarket) {
        this.listOfMarkets.forEach(e => {
          this.editedItem.promotionMarkets.push(e.id);
        });
      } else {
        this.editedItem.promotionMarkets = [];
      }
    },
    toggleObject() {
      this.$nextTick(() => {
        if (this.likesAllPromotionParties) {
          this.editedItem.promotionParties = [];
        } else {
          // this.editedItem.rateParties = this.select.applyFor.slice();
          this.promotionParties.forEach(x => {
            this.editedItem.promotionParties.push(x.value);
          });
        }
      });
    },
    addnotApplyDates() {
      if (this.editedItem.promotionBlackoutsBooking.length > 0) {
        let prevPeriod = this.editedItem.promotionBlackoutsBooking[
          this.editedItem.promotionBlackoutsBooking.length - 1
        ];
        let from = this._moment(prevPeriod.endBookingDate)
          .add(1, "day")
          .format("YYYY-MM-DD");
        let to = this._moment(prevPeriod.endBookingDate)
          .add(2, "day")
          .format("YYYY-MM-DD");
        this.editedItem.promotionBlackoutsBooking.push({
          startBookingDate: from,
          endBookingDate: to
        });
      } else {
        this.editedItem.promotionBlackoutsBooking.push({
          startBookingDate: this._moment(this.currentDatePicker)
            .add(4, "day")
            .format("YYYY-MM-DD"),
          endBookingDate: this._moment(this.currentDatePicker)
            .add(5, "day")
            .format("YYYY-MM-DD")
        });
      }
    },
    removeRangeApplyDate(index) {
      this.editedItem.promotionBlackoutsBooking.splice(index, 1);
    },
    addnotApplyDatesStay() {
      if (this.editedItem.promotionBlackoutsStaying.length > 0) {
        let prevPeriod = this.editedItem.promotionBlackoutsStaying[
          this.editedItem.promotionBlackoutsStaying.length - 1
        ];
        let from = this._moment(prevPeriod.endBookingDate)
          .add(1, "day")
          .format("YYYY-MM-DD");
        let to = this._moment(prevPeriod.endBookingDate)
          .add(2, "day")
          .format("YYYY-MM-DD");
        this.editedItem.promotionBlackoutsStaying.push({
          startBookingDate: from,
          endBookingDate: to
        });
      } else {
        this.editedItem.promotionBlackoutsStaying.push({
          startBookingDate: this._moment(this.currentDatePicker)
            .add(4, "day")
            .format("YYYY-MM-DD"),
          endBookingDate: this._moment(this.currentDatePicker)
            .add(5, "day")
            .format("YYYY-MM-DD")
        });
      }
    },
    removeRangeApplyDateStay(index) {
      this.editedItem.promotionBlackoutsStaying.splice(index, 1);
    },
    currentDate() {
      let today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //As January is 0.
      var yyyy = today.getFullYear();

      if (dd < 10) dd = "0" + dd;
      if (mm < 10) mm = "0" + mm;

      return yyyy + "-" + mm + "-" + dd;
    },
    _moment: moment,
    validatePromotionCode(roomCode) {
      let body = {
        keyword: roomCode
      };
      promotion.validatePromotionCode(body).then(async res => {
        if (res.responseCode == 0) {
          if (res.data) {
            this.isDuplicatePromotionCode = true;
          } else {
            this.isDuplicatePromotionCode = false;
          }
        }
      });
    }
  }
};
</script>
